import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaHastaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA HASTA' htmlFor='date-fechaHasta' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaHasta'>
          {({ field }) => (
            <Form.InputDate {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='date-fechaHasta' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaHastaFormGroup)
